export const SpecialEventValueTypes = {
  TEXT: "TEXT",
  BOOLEAN: "BOOLEAN",
  BOOLEAN_INCLUDED: "BOOLEAN_INCLUDED",
  DROPDOWN: "DROPDOWN",
  STATIC_DROPDOWN: "STATIC_DROPDOWN",
  STATIC_DROPDOWN_INCLUDED: "STATIC_DROPDOWN_INCLUDED"
};

// Mirrors ConversationsConsts.SkillFilters (same key/label values). Kept local — rather than
// imported — to avoid a circular import: ConversationsConsts.js already imports from
// ConversationExperienceQuery.consts.js, which needs this operator pair.
export const IncludesFilterOptions = {
  INCLUDES: {
    key: "INCLUDES",
    label: "Includes"
  },
  DOES_NOT_INCLUDE: {
    key: "DOES_NOT_INCLUDE",
    label: "Does not include"
  }
};

// For attributes that only take a list of values: "Is" / "Is not" labels that send the
// multi-value operators (keys match ConversationsConsts.IsOneOfFilter, kept local for the same reason).
export const MultiSelectIsIsNotFilter = {
  IS: {
    key: "IS_ONE_OF",
    label: "Is"
  },
  IS_NOT: {
    key: "IS_NOT_ONE_OF",
    label: "Is not"
  }
};

export const BooleanOptions = {
  TRUE: {
    key: "true",
    label: "True"
  },
  FALSE: {
    key: "false",
    label: "False"
  }
};

// The difference between BooleanOptions and BooleanIncludedOptions is:
// Boolean checks if the value is true/false
// BooleanIncluded checks if the event type is present in the convo
export const BooleanIncludedOptions = {
  IS_INCLUDED: {
    key: "IS",
    label: "Is included"
  },
  IS_NOT_INCLUDED: {
    key: "IS_NOT",
    label: "Is not included"
  }
};
